var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('LandingPage'),_c('tenant-switch-dialog',{ref:"refSwitchDialog"})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }